import type { ReelSection } from './deriveReelSections';

/**
 * PLAT-11073 — which Section the playhead is in, as a Section id (DE15).
 *
 * The last Section that has started, which needs no separate case for either
 * end: before the first Section's start the answer is the first one, and past
 * the last Section's end the playhead is still inside the last Section as far as
 * the panel is concerned. A time exactly on a boundary belongs to the Section
 * that starts there, never to the one that ends — the same reading
 * `reelInsertIndexAtTime` takes.
 *
 * `undefined` only when there are no Sections at all.
 */
export function sectionIdAtTime(
  sections: readonly ReelSection[],
  time: number,
): string | undefined {
  if (sections.length === 0) return undefined;

  for (let index = sections.length - 1; index > 0; index--) {
    if (time >= sections[index].startTime) return sections[index].id;
  }
  return sections[0].id;
}
